// Short confirmations ("Link copied.", "Published. It's live on your widget within a minute."). An optional
// action ({label, to}) adds a link to the next step, and keeps the toast up longer so there is time to use it.
import Vue from 'vue';

export const toastState = Vue.observable({ items: [] });
let sequence = 0;

export function toast(text, kind, action) {
  sequence += 1;
  const id = sequence;
  toastState.items.push({ id, text, kind: kind || 'success', action: action || null });
  if (toastState.items.length > 3) toastState.items.shift();
  window.setTimeout(() => {
    const index = toastState.items.findIndex(item => item.id === id);
    if (index >= 0) toastState.items.splice(index, 1);
  }, action ? 7000 : 3600);
}
